var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArVrDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58829 7.7696C4.63416 7.84066 4.69555 7.89876 4.76715 7.93889C4.83875 7.97903 4.91843 8 4.99932 8C5.08021 8 5.15989 7.97903 5.23149 7.93889C5.3031 7.89876 5.36448 7.84066 5.41035 7.7696L9.91071 0.836743C9.9628 0.756779 9.99335 0.663118 9.99903 0.565938C10.0047 0.468757 9.98532 0.371774 9.94295 0.285524C9.90058 0.199274 9.83686 0.127057 9.75871 0.0767191C9.68056 0.0263811 9.59097 -0.000152706 9.49967 6.61103e-07H0.49897C0.407884 0.000401918 0.318625 0.027277 0.24079 0.0777355C0.162955 0.128194 0.0994899 0.200327 0.0572196 0.286377C0.0149493 0.372427 -0.00452694 0.469139 0.000885468 0.566112C0.00629787 0.663084 0.0363941 0.756649 0.0879376 0.836743L4.58829 7.7696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArVrDownArrow);
export default __webpack_public_path__ + "static/media/arVrDownArrow.4bcf4048c73b1b79bba1cb4c55a605a0.svg";
export { ForwardRef as ReactComponent };